<div class="mt-3" id="js-container" [style.width]="interaction?.config?.containerWidth+'px'" [style.height]="interaction?.config?.containerHeight+'px'">
  <canvas class="canvas" id="js-canvas" [width]="interaction?.config?.containerWidth" [height]="interaction?.config?.containerHeight"></canvas>
  <div class="imagebelow" *ngIf="canShow || interaction?.completed.onComplete">
    <img [src]="interaction?.config?.imageBackgroundSrc" class="img-fluid">
  </div>
</div>